// src/constants/coverImages.js
import cover1 from '../assets/images/orgcovers/generic-cover.jpg';
import cover2 from '../assets/images/orgcovers/coverfsi.jpg';

// Extend this array with additional imported assets as needed
export const coverImages = [
  { name: 'Generic', src: cover1 },
  { name: 'Ferrovie', src: cover2 }
];

export default coverImages;
